<refactor-card-header>
  <div class="upload-modal">
    <div class="upload-header" *ngIf="uploadConfig">
      <h1 class="upload-title">{{ uploadConfig.title | translate }}</h1>
      <p class="upload-subtitle">{{ uploadConfig.subtitle | translate }}</p>
    </div>

    <div class="drop-container" [class.disabled]="isUploading"
      [class.drag-over]="isDragging" (click)="!isUploading && openFileInput()"
      (dragover)="!isUploading && onDragOver($event)" (dragleave)="!isUploading && onDragLeave($event)"
      (drop)="!isUploading && onDrop($event)">
      <div *ngIf="!isUploading; else uploading">
        <ion-icon name="file-tray" class="upload-icon"></ion-icon>
        <div class="upload-info" *ngIf="uploadConfig">
          <div class="upload-description"><b>{{ uploadConfig.description | translate }}</b></div>
          <div class="upload-filetypes">{{ uploadConfig.maxSize ? ('FILE_UPLOAD_POPOVER.MAX_SIZE' | translate:{max:
            uploadConfig.maxSize}) : '' }} {{ uploadConfig.fileTypes }}</div>
        </div>
      </div>
      <ng-template #uploading>
        <ion-spinner name="crescent"></ion-spinner>
        <p>{{'FILE_UPLOAD_POPOVER.UPLOADING'| translate }}</p>
      </ng-template>
      <input #fileInput type="file" [multiple]="uploadConfig.multiple || false"
        [accept]="uploadConfig.accept || '.zip,.pdf,.xls,.docx'" hidden (change)="handleFileUpload($event)" />
    </div>
    <div *ngIf="errorMessage" class="upload-error">{{ errorMessage }}</div>
  </div>
</refactor-card-header> 